import { Provider } from '@angular/core';
import { ClientRepositoryPort } from '../domain/repositories/client.repository.port';
import { ClientRepository } from './repositories/client.repository';

export const CLIENT_PROVIDERS: Provider[] = [
  {
    provide: ClientRepositoryPort,
    useClass: ClientRepository,
  },
];
